import * as React from 'react';
import {
    Button,
    Icon,
    Form,
    Checkbox,
    Radio,
    Dropdown,
    Header,
    Segment,
    Statistic,
    Loader,
    Dimmer,
    Input,
    Divider,
    Popup
} from 'semantic-ui-react';
import { Slider } from 'react-semantic-ui-range';
import { AxiosRequestConfig, AxiosResponse } from 'axios';
import axios from 'axios';
import OAuth from '../../api';
import 'react-semantic-ui-range/range.css';
import 'semantic-ui-css/semantic.min.css';

class CaptureConfig {
    enabled: boolean;
    buffer: {
        size: number;
        min: number;
        max: number;
    };
    mediaExport: boolean;
    triggers: {
        daiSplice: string[];
        events: string[];
        httpStatus: string;
        position: number;
    };
    filter: {
        ports: string[];
        protocols: string[];
        stream?: number;
        streamRef?: {
            streamName: string;
            assetName: string;
        };
    };
}

class CaptureStatus {
    state: string;
    triggers: string[];
    status: string[];
}

class Stream {
    streamid: number;
    name: string;
    streamType: string;
    master: boolean;
    assetName: string;
    url: string;
    state: string;
}

class State {
    fetching: {
        configuration: boolean;
        status: boolean;
        metadata: boolean;
        streams: boolean;
        control?: string;
    };

    streams?: Stream[];
    metadata: {
        files: {
            packets: string;
            mediaExports: string;
        },
        triggers: string[];
        protocols: string[];
        daiSplice: string[];
    };
    ports ?: string[];
    capturing: boolean;
    hasMedia: boolean;
    hasPackets: boolean;
    adhoc: boolean;
    capture?: CaptureConfig;
    status?: CaptureStatus;
}

interface Props {

}

const triggerDescMap = {
    vs_error: 'VS Error',
    vs_error_period: 'VS Error Period',
    frb_sys_min: false,
    frb_ft_max: false,
    seq_error: 'Sequence Error',
    stalled_im: 'Stalled Index/Manifest Event',
    decrypt_error: 'Decryption Error',
    audio_np: 'Audio Not Present',
    file_dur_error: 'Media File Duration',
    audio_sync_error: 'Video/Audio Sync Error',
    dns_error: 'DNS Error',
    ip_addr_change: 'IP Address Change',
    http_status_redirect: 'HTTP Redirect Status',
    http_status_error: 'HTTP 4xx/5xx Status',
    dns_time_error: 'DNS Timing Error',
    conn_time_error: 'Connection Timing Error',
    conn_error: 'Connection Error',
    vsf: 'Video Start Failure',
    dvst_time_error: 'Derived Variant Startup Time Error Event',
    pl_file_error: 'Playlist File Error',
    text_fmt_error: 'Text Format Error Event',
    text_cap_cnt_error: 'Text Caption Count Error Event',
    mpd_period_change: 'MPD Period Change Event',
    dai_splice_event: 'DAI Splice Event',
    dai_interval_error: 'DAI Interval Error Event',
    dai_playback_duration: 'DAI Playback Duration Error Event',
    dai_splice_seq_error: 'DAI Splice Sequence Error'
};

export default class CaptureView extends React.Component<Props, State> {
    private timer: any;

    private static setMap(collection: string[], key: string | string[], present: boolean): string[] {
        if (Array.isArray(key)) {
            // add or remove all keys
            // tslint:disable-next-line:no-console
            console.log('set all: ', key);
            let c = collection;
            key.forEach(k => c = CaptureView.setMap(c, k, present));
            // tslint:disable-next-line:no-console
            console.log('set all result: ', c);
            return c;
        }
        const exists = collection.indexOf(key) >= 0;
        if ((exists && present) || (!exists && !present))
            return collection;    // no-op as collection already matches desired state
        return present
            ? collection.concat(key)
            : collection.filter(k => k !== key);    // take all elements not equal to 'key'
    }

    constructor(props: Props) {
        super(props);
        this.fetchPorts();
        this.triggerOptionChanged = this.triggerOptionChanged.bind(this);
        this.state = {
            fetching: {
                configuration: true,
                status: true,
                metadata: false,
                streams: false
            },
            metadata: {
                files: {
                    packets: '/adpcapture/IQADPCapture.pcap',
                    mediaExports: '/adpcapture/IQADPCapture.ts'
                },
                triggers: [
                    'manual',
                    'vs_error',
                    'vs_error_period',
                    'frb_sys_min',
                    'frb_ft_max',
                    'seq_error',
                    'stalled_im',
                    'decrypt_error',
                    'audio_np',
                    'file_dur_error',
                    'audio_sync_error',
                    'dns_error',
                    'ip_addr_change',
                    'http_status_redirect',
                    'http_status_error',
                    'dns_time_error',
                    'conn_time_error',
                    'conn_error',
                    'vsf',
                    'dvst_time_error',
                    'pl_file_error',
                    'text_fmt_error',
                    'text_cap_cnt_error',
                    'mpd_period_change',
                    'dai_splice_event',
                    'dai_interval_error',
                    'dai_playback_duration',
                    'dai_splice_seq_error'
                ],
                protocols: [
                    'tcp',
                    'udp',
                    'dns',
                    'arp'
                ],
                daiSplice: [
                    'dai_splice_out',
                    'dai_splice_in'
                ]
            },
            adhoc: true,
            capturing: false,
            hasMedia: false,
            hasPackets: false,
        };

        // queue up some data fetches
    }

    componentDidMount() {
        this.fetchConfiguration();
        this.getStreams(true);
        this.fetchStatus();
        if (!this.timer) {
            this.timer = setInterval(() => {
                if (!this.state.fetching.status) this.fetchStatus();
            },                       500);
        }
    }

    componentWillUnmount() {
        if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
        }
    }

    /* event handlers */
    handleCaptureMode = (e: React.SyntheticEvent<HTMLInputElement>, data: any) => this.state.capture && this.setState({
        adhoc: data.value === 'adhoc',
        capture: {...this.state.capture, filter: {...this.state.capture.filter}}
    },                                                                                                                () => this.sendConfiguration( false ))
    // tslint:disable-next-line:max-line-length
    triggerOptionChanged = (e: React.SyntheticEvent<HTMLInputElement> | null, data: any) => this.state.capture && this.setState({
        capture: {
            ...this.state.capture,
            triggers: {
                ...this.state.capture.triggers,
                events: CaptureView.setMap(this.state.capture.triggers.events, data.value, data.checked)
            }
        }
    },                                                                                                                          () => this.sendConfiguration( false ))
    // tslint:disable-next-line:max-line-length
    daiSpliceChanged = (e: React.SyntheticEvent<HTMLInputElement> | null, data: any) => this.state.capture && this.setState({
        capture: {
            ...this.state.capture,
            triggers: {
                ...this.state.capture.triggers,
                daiSplice: CaptureView.setMap(this.state.capture.triggers.daiSplice, data.value, data.checked)
            }
        }
    },                                                                                                                      () => this.sendConfiguration( false ))
    // tslint:disable-next-line:max-line-length
    portsOptionChanged = (e: React.SyntheticEvent<HTMLInputElement>, data: any) => this.state.capture && this.setState({
        capture: {
            ...this.state.capture,
            filter: {
                ...this.state.capture.filter,
                ports: CaptureView.setMap(this.state.capture.filter.ports, data.value, data.checked)
            }
        }
    },                                                                                                                 () => this.sendConfiguration( false ))
    // tslint:disable-next-line:max-line-length
    protocolsOptionChanged = (e: React.SyntheticEvent<HTMLInputElement>, data: any) => this.state.capture && this.setState({
        capture: {
            ...this.state.capture,
            filter: {
                ...this.state.capture.filter,
                protocols: CaptureView.setMap(this.state.capture.filter.protocols, data.value, data.checked)
            }
        }
    },                                                                                                                     () => this.sendConfiguration( false ))

    // streamOptionChanged = (e: React.SyntheticEvent<HTMLInputElement>, data: any) => this.state.capture && this.setState({ capture: { ...this.state.capture, filter: { ...this.state.capture.filter, stream: data.value } }});
    handleStreamFilterSelector = (e: React.SyntheticEvent<HTMLInputElement>, data: any) => this.state.capture && this.setState({
        capture: {
            ...this.state.capture,
            filter: {...this.state.capture.filter, stream: data.value}
        }
    },                                                                                                                         () => this.sendConfiguration( false ))

    handleClearStreamFilterClick = () => this.state.capture && this.setState({
        capture: {
            ...this.state.capture,
            filter: {...this.state.capture.filter, stream: undefined}
        }
    },                                                                       () => this.sendConfiguration( false ))

    handleMediaExportChanged = (e: React.SyntheticEvent<HTMLInputElement>, data: any) => this.state.capture && this.setState({
         capture: {
             ...this.state.capture,
             mediaExport: data.checked
         }
     },                                                                                                                      () => this.sendConfiguration( false ))

    handleBufferSlider = (value: any) => this.state.capture && this.setState({
        capture: {
            ...this.state.capture,
            buffer: {...this.state.capture.buffer, size: value}
        }
    },                                                                       () => this.sendConfiguration( false ))

    handleTriggerPositionSlider = (value: any) => this.state.capture && this.setState({
        capture: {
            ...this.state.capture,
            triggers: {...this.state.capture.triggers, position: value}
        }
    },                                                                                () => this.sendConfiguration( false ))

    handleHttpStatusUpdate = (e: React.SyntheticEvent<HTMLInputElement>, data: any) => this.state.capture && this.setState({
        capture: {
            ...this.state.capture,
            triggers: {...this.state.capture.triggers, httpStatus: data.value}
        }
    },                                                                                                                     () => this.sendConfiguration( false ))

    // button handler event that directly map to API control calls
    handleControlButtonClick = (op: string) => this.control(op).then(() => this.fetchStatus());

    triggerOption(id: string, children?: (id: string) => JSX.Element) {
        let desc = triggerDescMap[id] || id;
        let child1 = children ? children(id) : undefined;
        let child2 = children ? children(id) : undefined;
        // tslint:disable-next-line:no-shadowed-variable
        let styles: any = {marginTop: 3, marginRight: 15, paddingLeft: 8};
        if (this.state.status && Array.isArray(this.state.status.triggers) && this.state.status.triggers.indexOf(id) >= 0)
            styles = {
                ...styles,
                borderLeft: '4px solid #9e010177',
                paddingLeft: 4
            };
        // render our trigger checkbox
        let ctrl = (
            <Checkbox
                label={desc}
                name="triggers"
                value={id}
                checked={this.state.capture && this.state.capture.triggers.events.indexOf(id) >= 0}
                onChange={this.triggerOptionChanged}
                style={styles}
            />
        );

        if (id === 'http_status_error') {
            // tslint:disable-next-line:jsx-wrap-multiline
            child1 = <Input
                disabled={this.state.capture && this.state.capture.triggers.events.indexOf(id) >= 0 ? false : true}
                className="small-input"
                // @ts-ignore
                value={this.state.capture.triggers.httpStatus}
                maxLength={20}
                // @ts-ignore
                onChange={this.handleHttpStatusUpdate}
            />;
        }

        if (id === 'dai_splice_event') {
            this.state.metadata.daiSplice.map((data, idx) => {
                if (idx === 0) {
                    child1 =
                        // tslint:disable-next-line:jsx-wrap-multiline
                        <Checkbox
                            label={'Splice Out'}
                            name="splices"
                            value={data}
                            disabled={this.state.capture && this.state.capture.triggers.events.indexOf('dai_splice_event') >= 0 ? false : true}
                            checked={this.state.capture && this.state.capture.triggers.daiSplice.indexOf(data) >= 0}
                            onChange={this.daiSpliceChanged}
                            style={{marginRight: 15}}
                        />;
                } else {
                    child2 =
                        // tslint:disable-next-line:jsx-wrap-multiline
                        <Checkbox
                            label={'Splice In'}
                            name="splices"
                            value={data}
                            disabled={this.state.capture && this.state.capture.triggers.events.indexOf('dai_splice_event') >= 0 ? false : true}
                            checked={this.state.capture && this.state.capture.triggers.daiSplice.indexOf(data) >= 0}
                            onChange={this.daiSpliceChanged}
                            style={{marginRight: 15}}
                        />;
                }

            });
        }

        // now depending on if we have a child, render the elements
        return (
            <div key={id} style={styles.triggerOption}>
                {ctrl} {child1} {child2}
            </div>
        );
    }

    renderTriggerGroup(title: string, triggers: string[]) {
        if (!this.state.capture)
            return null;
        return (
            <div>
                <Header
                    as="h4"
                    onClick={() => this.triggerOptionChanged(null, {
                        checked: true,
                        value: triggers
                    })}
                >{title}
                </Header>
                <Form.Group grouped style={styles.triggerGroup}>
                    {triggers.map(t => this.triggerOption(t))}
                </Form.Group>
            </div>
        );
    }

    fetchPorts() {
        // tslint:disable-next-line:variable-name
        let __this = this;
        axios.get('http://default/api/capture/ports')
            .then(function (response: AxiosResponse) {
                if (response.data !== undefined) {
                    __this.setState({
                        ports: response.data.ports
                    });
                }
            })
            .catch(function (error: AxiosRequestConfig) {
                // tslint:disable-next-line:no-console
                console.log('fetchPorts() error: ', error);
            });
    }

    fetchConfiguration() {
        this.setState({fetching: {...this.state.fetching, configuration: true}});
        axios.get('http://default/api/capture/configure')
            .then((resp: AxiosResponse) => {
                if (resp.data !== undefined && resp.data.code === 'SUCCESS') {
                    let response = resp.data.capture;
                    if (response === undefined || response.triggers === undefined)
                        throw 'response is not a capture config object';
                    // tslint:disable-next-line:no-console
                    console.log('capture-config => ', response);
                    this.setState({
                        adhoc: response.filter.stream === undefined,
                        capture: response,
                        fetching: {...this.state.fetching, configuration: false}
                    });
                } else {
                    // todo: we can probably just throw here and let the .catch below set state
                    throw resp.data.det;
                }
            })
            .catch((err: AxiosRequestConfig) => {
                // tslint:disable-next-line:no-console
                console.log('fetchData() error: ', err);
                this.setState({fetching: {...this.state.fetching, configuration: false}});
            });
    }

    sendConfiguration(isLoadable: boolean) {
        return new Promise((resolve, reject) => {
            if (isLoadable) {
                this.setState({fetching: {...this.state.fetching, configuration: true}});
            }
            axios.post('http://default/api/capture/configure', {
                capture: this.state.capture
            })
                .then((resp: AxiosResponse) => {
                    if (resp.data !== undefined && resp.data.code === 'SUCCESS') {
                        let response = resp.data.capture;
                        if (response === undefined || response.triggers === undefined)
                            throw 'response is not a capture config object';
                        if (isLoadable) {
                            this.setState({fetching: {...this.state.fetching, configuration: false}});
                        }
                        this.setState({capture: response});
                        resolve(response);
                    } else {
                        // todo: we can probably just throw here and let the .catch below set state
                        throw resp.data.det;
                    }
                })
                .catch((err: AxiosRequestConfig) => {
                    // tslint:disable-next-line:no-console
                    console.log('fetchData() error: ', err);
                    this.setState({fetching: {...this.state.fetching, configuration: false}});
                    reject(err);
                });
        });
    }

    fetchStatus() {
        this.setState({fetching: {...this.state.fetching, status: true}});
        axios.get('http://default/api/capture/status')
            .then((resp: AxiosResponse) => {
                if (resp.data !== undefined && resp.data.code === 'SUCCESS') {
                    let {state, triggers, status} = resp.data;
                    if (state === undefined || status === undefined || triggers === undefined || !Array.isArray(triggers))
                        throw 'response is not a capture status object';
                    // look for certain status text lines and pull out state
                    let matches: any;
                    // check for complete status with packets and bytes update
                    let regex = RegExp(/captured: ([0-9,]+) packets ([0-9,]+\.?\d*) ([MGK])bytes/g);
                    if (status.length > 2 && status[0] === 'COMPLETE' && (matches = regex.exec(status[1])) && matches.length >= 3) {
                        this.setState({
                            hasPackets: parseInt(matches[1], 10) > 0,
                            hasMedia: parseFloat(matches[2]) > 0
                        });
                    }
                    // set the status in the state
                    this.setState({
                        status: {state, triggers, status},
                        fetching: {...this.state.fetching, status: false}
                    });
                } else {
                    // todo: we can probably just throw here and let the .catch below set state
                    throw resp.data.det;
                }
            })
            .catch((err: AxiosRequestConfig) => {
                // tslint:disable-next-line:no-console
                console.log('cannot get capture status : ', err);
                this.setState({
                    fetching: {...this.state.fetching, status: false},
                    status: {state: 'error', triggers: [], status: []}
                });
            });
    }

    control(op: string) {
        return new Promise((resolve, reject) => {
            this.setState({fetching: {...this.state.fetching, control: op}});
            axios.post('http://default/api/capture/control/' + op)
                .then((resp: AxiosResponse) => {
                    if (resp.data !== undefined && resp.data.code === 'SUCCESS') {
                        this.setState({fetching: {...this.state.fetching, control: undefined}});
                        resolve(resp.data);
                        this.fetchStatus();
                    } else {
                        // todo: we can probably just throw here and let the .catch below set state
                        throw resp.data.det;
                    }
                })
                .catch((err: AxiosRequestConfig) => {
                    // tslint:disable-next-line:no-console
                    console.log('cannot get capture status : ', err);
                    this.setState({fetching: {...this.state.fetching, control: undefined}});
                    reject(err);
                });
        });
    }

    getStreams(fetch: boolean = true) {
        // tslint:disable-next-line:variable-name
        const __this = this;
        // if we got a set, then return immediately
        if (this.state.streams !== undefined)
            return this.state.streams;
        // if we are fetching already, then just return empty set
        if (this.state.fetching.streams)
            return [];
        // set state that we are loading
        __this.setState({fetching: {...__this.state.fetching, streams: true}});
        if (fetch) {
            axios.get('http://default/api/stream/status?streams=all',
                      {headers: {'x-orderby': 'order streams by name'}})
                .then(function (resp: AxiosResponse) {
                    if (resp.data !== undefined && resp.data.code === 'SUCCESS') {
                        let response = resp.data.streams;
                        if (!Array.isArray(response))
                            throw 'Response is not an array of streams';
                        // map the incoming object to only the fields we are interested in
                        let streams = response.map(({streamid, name, streamType, master, assetName, url, state}: any): Stream => {
                            return {streamid, name, streamType, master, assetName, url, state};
                        });
                        // console.log("got streams => ", streams);
                        // hold the streams in state
                        __this.setState({fetching: {...__this.state.fetching, streams: false}, streams});
                    } else {
                        // todo: we can probably just throw here and let the .catch below set state
                        __this.setState({fetching: {...__this.state.fetching, streams: false}});
                        // tslint:disable-next-line:no-console
                        console.log('expected array of streams, got ', resp.data);
                    }
                })
                .catch(function (err: AxiosRequestConfig) {
                    // tslint:disable-next-line:no-console
                    console.log('fetchData() error: ', err);
                    __this.setState({fetching: {...__this.state.fetching, streams: false}, streams: []});
                    // todo: attempt to load again in 10 seconds
                });
        }
        return [];
    }

    renderView() {
        // return loading of we dont have configuration or metadata
        if (this.state.fetching.configuration || this.state.fetching.metadata || !this.state.capture)
            return <Dimmer active><Loader size="medium" content="Loading"/></Dimmer>;

        /* render the main Capture UI view
         */

        // get the list of streams, may cause a fetch or use cached results
        let streams = this.getStreams(false);

        // deconstruct and calculate state flags
        let {capture, status, adhoc, fetching} = this.state;
        let controlPending = fetching.control !== undefined;   // there is an API control operation in progress
        let idle = status && status.state === 'idle';
        let waiting = status && status.state === 'waiting';
        let capturing = status && (status.state === 'triggered' || status.state === 'capturing');
        let complete = status && status.state === 'complete';
        let ready = idle || complete;
        let disabled = !ready || controlPending || (!adhoc && capture.filter.stream === undefined);

        let mediaExportElement =
            // tslint:disable-next-line:jsx-wrap-multiline
            <Checkbox
                color="grey"
                label="Extract MPEG-2 Transport Stream"
                disabled={!idle}
                checked={capture.mediaExport}
                style={{flexGrow: 1}}
                onChange={this.handleMediaExportChanged}
            />;

        let bufferSizeSegment =
            // tslint:disable-next-line:jsx-wrap-multiline
            <Segment basic disabled={!idle}>
            <div style={{display: 'flex', fontSize: '90%'}}>
                <span>Buffer Size</span>
                <Slider
                    color="blue"
                    style={{width: 200}}
                    settings={{
                        min: capture.buffer.min,
                        max: capture.buffer.max,
                        start: capture.buffer.size,
                        step: 5,
                        onChange: this.handleBufferSlider
                    }}
                />
                <Statistic size="mini" style={{margin: 0, width: 50}}>
                    <Statistic.Value>{capture.buffer.size}</Statistic.Value>
                    <Statistic.Label>MB</Statistic.Label>
                </Statistic>
            </div>
        </Segment>;

        // tslint:disable-next-line:jsx-wrap-multiline
        return <React.Fragment>
            <Segment.Group className="capture-status" style={styles.panel}>
                <Header as="h3" attached="top">
                    Status
                </Header>
                <Segment attached className="capture-status" style={{backgroundColor: '#f3f3f3', height: 140}}>
                    {this.state.status && this.state.status.status && this.state.status.status.map((s, idx) => {
                        return <div key={idx}>{s}</div>;
                    })}
                </Segment>
                <Segment
                    attached
                    className="capture-control"
                    style={{display: 'flex', justifyContent: 'space-between'}}
                >
                    <Button.Group>
                        <Button disabled className="button-label">
                            Capture Control
                        </Button>

                        <Button
                            icon
                            loading={fetching.control === 'start'}
                            positive={!disabled}
                            disabled={disabled}
                            labelPosition="left"
                            onClick={() =>
                                this.sendConfiguration(true)
                                    .then(() => this.control('start'))
                                    .then(() => this.setState({
                                        capturing: true,
                                        hasPackets: false,
                                        hasMedia: false
                                    }))
                            }
                        >
                            <Icon name="play"/>Start
                        </Button>

                        <Button
                            icon
                            loading={fetching.control === 'stop'}
                            negative={capturing || waiting}
                            disabled={idle || complete || controlPending}
                            labelPosition="right"
                            onClick={() =>
                                this.control('stop')
                                    .then(() => this.setState({
                                        capturing: false,
                                        hasMedia: capture.mediaExport,
                                        hasPackets: true
                                    }))}
                        >
                            <Icon name="stop"/>Stop
                        </Button>
                    </Button.Group>

                    <Button.Group>
                        <Button
                            icon
                            loading={fetching.control === 'trigger'}
                            color={!adhoc && waiting ? 'blue' : undefined}
                            disabled={adhoc || !waiting || controlPending}
                            labelPosition="left"
                            onClick={() =>
                                this.control('trigger')
                                    .then(() => this.setState({capturing: false}))}
                        >
                            <Icon name="lightning"/>{'Trigger Now'}
                        </Button>
                    </Button.Group>

                    <div>
                        <Button.Group>
                            <Button disabled className="button-label">
                                Download
                            </Button>

                            <OAuth.Context>
                                {(oauth: any) => {
                                    return <React.Fragment>
                                            <Button
                                                icon
                                                positive={this.state.hasPackets}
                                                disabled={!complete || !this.state.hasPackets}
                                                labelPosition="left"
                                                onClick={() => window.open(oauth.resolveServerUrl(this.state.metadata.files.packets))}
                                            >
                                                <Icon name="download"/>Packets
                                            </Button>

                                            <Button
                                                icon
                                                positive={complete && capture.mediaExport}
                                                disabled={!complete || !capture.mediaExport}
                                                labelPosition="left"
                                                onClick={() => window.open(oauth.resolveServerUrl(this.state.metadata.files.mediaExports))}
                                            >
                                                <Icon name="download"/>Media
                                            </Button>
                                        </React.Fragment>;
                                }}
                            </OAuth.Context>

                        </Button.Group>
                    </div>

                    <Button.Group>
                        <Button
                            icon
                            negative={complete}
                            loading={fetching.control === 'release'}
                            disabled={!complete || controlPending}
                            labelPosition="left"
                            onClick={() =>
                                this.control('release')
                                    .then(() => this.setState({
                                        capturing: false,
                                        hasPackets: false,
                                        hasMedia: false
                                    }))}
                        >
                            <Icon name="trash"/>Release
                        </Button>
                    </Button.Group>

                </Segment>
            </Segment.Group>

            <div className="config-panels">
                <div>
                    <Segment.Group className="capture-options" style={styles.panel}>
                        <Header as="h3" disabled={!ready} attached="top">
                            Options
                        </Header>
                        <Form>
                            <Segment attached className="dimmer-light">
                                {/*<Dimmer active={!idle}>*/}
                                {/*    <h6>Release capture to change options</h6>*/}
                                {/*</Dimmer>*/}
                                <Form.Group grouped style={styles.captureOptions}>
                                    <div>
                                        <Form.Field>
                                            <Radio
                                                label="Ad&nbsp;hoc"
                                                name="captureType"
                                                value={'adhoc'}
                                                disabled={!ready}
                                                checked={adhoc}
                                                onChange={this.handleCaptureMode}
                                            />
                                        </Form.Field>
                                        <Form.Field>
                                            <Radio
                                                label="Trigger Mode"
                                                name="captureType"
                                                value={'trigger'}
                                                disabled={!ready}
                                                checked={!adhoc}
                                                onChange={this.handleCaptureMode}
                                            />
                                        </Form.Field>
                                    </div>
                                    {!idle ?
                                        <Popup inverted content="Release capture to enable" trigger={mediaExportElement} />
                                        :
                                        mediaExportElement
                                    }
                                    {!idle ?
                                        <Popup inverted content="Release capture to enable" trigger={bufferSizeSegment} />
                                        :
                                        bufferSizeSegment
                                    }

                                </Form.Group>
                            </Segment>
                        </Form>
                    </Segment.Group>

                    <Segment.Group className="capture-triggers dimmer-light" style={styles.panel}>
                        <Header as="h3" disabled={!ready} attached="top">
                            Triggers
                            <div style={{display: 'flex', fontSize: '60%', float: 'right'}}>
                                <span>Trigger Buffer Position</span>
                                <Slider
                                    color="blue"
                                    style={{width: 200}}

                                    settings={{
                                        min: 0,
                                        max: 100,
                                        start: capture.triggers.position,
                                        step: 1,
                                        onChange: this.handleTriggerPositionSlider
                                    }}
                                />
                                <span style={{width: 35, textAlign: 'right'}}>{capture.triggers.position}%</span>
                            </div>
                        </Header>
                        <Dimmer active={adhoc}>
                            <h6>Trigger options not available in ad hoc mode</h6>
                        </Dimmer>
                        <Segment attached disabled={!ready}>
                            <Form style={{display: 'flex'}}>
                                {this.renderTriggerGroup('ABR Protocol', [
                                    'seq_error',
                                    'stalled_im',
                                    'decrypt_error',
                                    'audio_np',
                                    'file_dur_error',
                                    'audio_sync_error',
                                    'http_status_error',
                                    'pl_file_error',
                                    'text_fmt_error',
                                    'text_cap_cnt_error',
                                    'mpd_period_change',
                                    'dai_splice_event',
                                    'dai_interval_error',
                                    'dai_playback_duration',
                                    'dai_splice_seq_error'
                                ])}
                                {this.renderTriggerGroup('Accessibility', [
                                    'dns_error',
                                    'http_status_redirect',
                                    'dns_time_error',
                                    'conn_time_error',
                                    'conn_error',
                                    'ip_addr_change'
                                ])}
                                {this.renderTriggerGroup('Streaming Performance', [
                                    'vs_error',
                                    'vs_error_period',
                                    'vsf',
                                    'dvst_time_error'
                                ])}
                            </Form>
                        </Segment>
                    </Segment.Group>
                </div>

                <Segment.Group className="capture-filters" style={styles.streamsPanel}>
                    <Header as="h3" disabled={!ready} attached="top">Capture Filters</Header>

                            <Header as="h5" disabled={!ready} attached="top">Ethernet</Header>
                            <Form.Group grouped style={styles.triggerGroup}>
                                {this.state.ports && this.state.ports.map(p => {

                                    return <Segment disabled={!ready} attached key={p}>
                                            <Checkbox
                                                label={p}
                                                name="ports"
                                                value={p}
                                                disabled={!ready}
                                                checked={capture.filter.ports.indexOf(p) >= 0}
                                                onChange={this.portsOptionChanged}
                                                style={{marginRight: 15}}
                                            />
                                        </Segment>;
                                })}
                            </Form.Group>
                    
                            <Header as="h5" basic disabled={!ready} />
                                <Segment disabled={!ready}>
                                    <Header as="h5" disabled={!ready} attached="top">Streams</Header>

                                        <Segment disabled={!ready} attached style={{zIndex: 100}}>
                                            <Form>
                                                <Form.Group grouped style={{...styles.triggerGroup, display: 'flex'}}>
                                                    <Dropdown
                                                        placeholder={'Select Stream'}
                                                        fluid
                                                        search
                                                        selection
                                                        value={capture.filter.stream}
                                                        onChange={this.handleStreamFilterSelector}
                                                        options={streams.map((s: Stream) => {
                                                            return {value: s.streamid, text: s.name};
                                                        })}
                                                        style={{
                                                            backgroundColor: !adhoc && capture.filter.stream === undefined ? '#ffe7e7' : 'white'
                                                        }}
                                                    />
                                                    <Button
                                                        icon={'times'}
                                                        style={{marginLeft: 10}}
                                                        onClick={this.handleClearStreamFilterClick}
                                                    />
                                                </Form.Group>
                                            </Form>
                                    </Segment>

                        <Divider horizontal>Or</Divider>

                        <Header as="h5" disabled={!ready} attached="top">Protocols</Header>
                        <Form.Group grouped style={styles.triggerGroup}>
                            {this.state.metadata.protocols.map(p => {
                                return <Segment attached key={p}>
                                        <Checkbox
                                            label={p.toUpperCase()}
                                            name="protocols"
                                            value={p}
                                            disabled={!ready}
                                            checked={capture.filter.protocols.indexOf(p) >= 0}
                                            onChange={this.protocolsOptionChanged}
                                            style={{marginRight: 15}}
                                        />
                                    </Segment>;

                            })}
                        </Form.Group>
                    </Segment>
                </Segment.Group>
            </div>
        </React.Fragment>;
    }

    render() {
        return (
            <React.Fragment>
                <div className="view-content capture vertical-flex-main" id="systemConfig">
                    <div className="pageTitle">
                        <div className="page-title-block">
                            <div className="iq-temp-key-val">
                                <div className="iq-temp-val page-title-text">Capture</div>
                            </div>
                        </div>
                    </div>

                    {this.renderView()}
                </div>
            </React.Fragment>
        );
    }
}

const styles = {
    panel: {
        margin: '1em'
    },
    streamsPanel: {
        margin: '1em',
        flexGrow: 1
    },
    triggerGroup: {
        minWidth: 250
    },
    captureOptions: {
        display: 'flex',
        alignItems: 'center'
    },
    triggerOption: {
        display: 'block',
        margin: 10
    }
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/config/capture.tsx